import { Component, ElementRef, ViewEncapsulation, input, viewChild, output, inject } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApIconComponent } from '@ap/icon';
import { ApContentPipe } from '@ap/content';

import content from './floating-content-modal.content.json';

/**
 * Content container to render data inside the opening container for the floating action button
 **/
@Component({
    selector: 'ap-floating-content-modal',
    templateUrl: './floating-content-modal.component.html',
    styleUrls: ['./floating-content-modal.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApIllustrationComponent, ApIconComponent, ApContentPipe]
})
export class ApFloatingContentModalComponent {
    private readonly contentService = inject(ApContentService);

    /**
     * Minimize button ElementRef
     * @internal
     */
    private readonly minimizeButton = viewChild<ElementRef>('minimizeButton');

    public readonly title = input<string>(undefined);

    /**
     * Emits when action is chosen by user
     */
    protected readonly closeEvent = output<string>();

    public constructor() {
        this.contentService.addContentItems(content);
    }

    /**
     * Set focus to minimize button when opene
     */
    public focus(): void {
        this.minimizeButton().nativeElement.focus();
    }

    /**
     * Stop all `transitionEnd` events from `ng-content` from interfering with same event on parent container
     */
    protected contentTransitionEnd(e: Event) {
        e.stopPropagation();
    }
}
